const SectionSeparator = () => <hr className="border-slate-200 my-12 -mx-6" />

export default SectionSeparator
